import React from 'react'
import { MdArrowBackIosNew } from "react-icons/md";


function Ramzan() {
  return (
    <div className='contain'>
        <div className="page-header">
          <span className="backBtn" onClick={()=> window.history.back()}>
            <MdArrowBackIosNew />
          </span>
          <div className="page-header__content">
            <h1 className="pagetitle">Fazail-E-Ramzan</h1>
          </div>
       </div>
       <div className="contentSection-card">
            <p className="contentSection_title--content">
            Ramzan ka Mubarak Maheena un Azeem Nemato me se ek intihayi azeem nemat hai
             jo Allah Paak ne ummat-E-Muslima ko inayat farmayi hai.
            </p>
            <p className="contentSection_title--content">
            Allah Paak Quran-E-Kareem me irshad farmata hai :
            </p>
             <p className="contentSection_title--content">
                Ae imaan walo ! Tum par Roze farz kiye gaye hain jaise aglo
                 par farz hue the ki kahi tumhe parhezgari mile.
                 <span className='referenceTag'>
                [Surah Al-Baqarah 2:183 ]
                </span> 
             </p>

             <p className="contentSection_title--content">
             Ramzan-ul-Mubarak ki Azmate aur Barkato ka kya hi kahna jise khud Huzur Nabi-E-Kareem
              صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne badi Azmat aur Barkat wala Maheena kaha ho to iski azmat aur 
              bulandiyo'n ka tasawwur na to kiya ja sakta hai aur na hi hamari zaban iski sari barkate 
              bayan kar sakti hai 
             </p>

             <p className="contentSection_title--content">
             Ramzan Shareef ke roze har Musalman, Aaqil, Mard aur Aurat par farz hai , aur iska inkar
              karne wala Kafir aur bila uzr chhorne wala sakht gunahgar aur fasik hai.
              </p>

              <h3 className="contentSection_subtitle">Sehri Ka Bayan :</h3>
              <p className="contentSection_title--content">
              Sehri Ki Fazilat ke Ta’aluq Se Huzoor Rehmate Do Aalam Sarwar e Kaunein 
              صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم Ke Chand Irshadat..
              </p>

              <p className="contentSection_title--content">
              “Sehri Khaya Karo Kyuki Sahri Me Barkat He
              </p>
              <span className='referenceTag'>
                [ Muslim Shareef, Hadees-2549 ]
                </span> 
              <p className="contentSection_title--content">
              Hamare Aur Ahle Kitaab (Yani Yahood-O-Nasara) Ke Darmiyaan Sehri Khane Ka Farq Hai”.
              </p>
              <span className='referenceTag'>
                 [Muslim Shareef, Safa-552, Hadees-1096]
              </span>
              <p className="contentSection_title--content">

              </p>


              <p className="contentSection_title--content">
              “Allah Azzawajal Aur Uske Farishte Sehri Khane Waalo Par Rahmat Naazil Farmate He”.
              </p>
              <span className='referenceTag'>
              [Sahih Ibn Hibban, Jild-5, Safa-194, Hadees-3458]
              </span>
              <p className="contentSection_title--content">
              “Huzoor Nabi E Kareem Sallallaho Alayhe Wasallam Apne Sath Jab Kisi Sahaabi Ko 
              Sehri Khane Ke Liye Bulaate To Irshaad Farmate “Aao Barkat Ka Khana Khaa Lo”.
              </p>
              <span className='referenceTag'>
              [Sunaane Abu Daawud, Jild-2, Safa-442, Hadees-2344]
              </span> 
              <p className="contentSection_title--content">
              “Roza Rakhne Ke Liye Sehri Khaa Kar Quwwat Haasil Karo Aur Din(Ya’ni Do-Pahar) 
              Ke Waqt Aaram Karke Raat Ki Ibaadat Ke Liye Taaqat Haasil Karo”.
              </p>
              <span className='referenceTag'>
              [Sunaane Ibne Maajah, Jild-2, Safa-321, Hadees-1693]
              </span>
              <p className="contentSection_title--content">
              “Sehri Barkat Ki Chiz He Jo Allah Ta’ala Ne Tumko Ataa Farmaayi He Is Ko Mat Chhodna”.
              </p>
              <span className='referenceTag'>
              [Sunaane Nasaai, Jild-2, Safa-79, Hadees-2472]
              </span>
              <p className="contentSection_title--content">
              “3 Aadmi Jitna Bhi Khaa Le In Sha Allah Unse Koi Hisaab Na Hoga (Ba-Sharte Ki Khana Halaal Ho) 1) Rozadaar
               Iftar Ke Waqt, 2) Sehri Khane Waale, 3) Mujaahid Jo Allah Ta’ala Ke Raste Me Sarhad-E-Islaam Ki Hifazat Kare”.
              </p>
              <span className='referenceTag'>
              [Attargib Wattarhib,Jild-2, Safa-90, Hadees-9]
              </span>
              <p className="contentSection_title--content">
              3 Chizo Ko Allah Mahboob Rakhta Hai 1) Iftaar Me Jaldi 2) 
              Sehri Me Takheer 3) Namaz Ke Qiyaam Me Hath Par Hath Rakhna
              </p>
              <span className='referenceTag'>
              [At-Targheeb Wat’tarheeb, Jild-2, Safa-91, Hadith-4]
              </span>
              <p className="contentSection_title--content">
              “Sehri Poori Ki Poori Barkat hai Pas Tum Na Chhodo Chaahe Yahi Ho 
              Ki Tum Paani Ka Ek Ghunt Pee Lo, Beshak Allah Ta’ala Aur Uske Farishte 
              Rahmat Bhejte hai Sehri Karne Waalo Par”.
              </p>
              <span className='referenceTag'>
              [Musnade Ahmad Bin Hambal, Jild-4, Safa-88, Hadees-11396]
              </span>
              <p className="contentSection_title--content">
              “Hazrate Saiyyadna Irbaaz Bin Saariya Radiallaho Ta’ala Anho Bayaan Karte He Ki Ek Baar 
              Ramzaan Ul Mubaarak Me Huzoor Nabi E Kareem Sallallaho Alayhe Wasallam Ne Mujhe Apne
               Saath Sehri Khane Ke Liye Bulaya Aur Farmaya “Aao Mubaarak Khane Ke Liye”.
              </p>
              <span className='referenceTag'>
              [Sunaane Abu Daawud, Jild-2, Safa-442, Hadees-2344]
              </span>
              <p className="contentSection_title--content">
              Khajoor Momin Ki Behtareen Sehri Hai.
              </p>
              <span className='referenceTag'>
              [Sunan Abu Dawood, Jild-2, Safa-443, Hadees-2345]
              </span>
              <p className="contentSection_title--content">
              Hazrat Anas Radi Allahu Anhu Farmate Hai, Aap صلی اللہ علیہ وسلم Sehri 
              Ke Waqt Mujh Se Farmate "Mera Roza Rakhne Ka Irada Hai, Mujhe Kuch Khilaao! 
              Toh Mai Kuch Khajoor Aur Ek Bartan Me Paani Pesh Karta".
              </p>
              <span className='referenceTag'>
              [Sunan Al-Kubra, Jild-2, Safa-80, Hadith-2477]
              </span>
              <p className="contentSection_title--content">
              In Tamam Faramin Se Hame Yahi Dars Milta He Ki Sehri Hamare Liye 
              Ek Azeem Ne’amat He Jis Se Be Sumaar Jismaani Aur Roohani Fawaaid Haasil Hote.'
              </p>
              <h3 className="contentSection_subtitle"> Taraweeh Ka Bayan :</h3>
              <p className="contentSection_title--content">
              Huzur Nabi-E-Kareem صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne irshaad farmaya , jisne Ramzan ki 
              raato me (bedaar rah kar) Namaaz (taraweeh) padhi, Imaan aur sawaab ki niyat ke 
              sath, uske pichle tamam gunaah maaf ho jayenge.
              </p>
              <span className='referenceTag'>
                Bukhari Shareef : 2009
                </span>
              <p className="contentSection_title--content">
                Sawaal. Taraweeh Sunnat ha ya nafl..?
                </p>
              <p className="contentSection_title--content">
              Jawaab: Taraweeh Mard wa Aurat sabke liye Sunnat-E-Muakkida hai. iska chhodna Jaiz nahi.
              </p>
              <h4 className="contentSection_subheading"> Taraweeh ki Niyat :</h4>
              <p className="contentSection_title--content">
              Niyat ki maine 2 rakat namaz taraweeh sunnat Rasool Allah ki , Allah ta'ala ke liye peeche
               is imaam ke Muh mera kaaba shareef ki taraf Allahu Akbar.
              </p>
            
              <p className="contentSection_title--content">
              Taraweeh Jama'at se pdhna Sunnat-E-kiffaya hai, yaani agar masjid me taraweeh ki Jama'at na hui 
              to muhalle ke sab log gunahgaar hue aur agar kuch logo ne masjid me jama'at se padh li to sab 
              log chutkara pa gyae.
              </p>
            
              <p className="contentSection_title--content">
              bila uzr (majboori) baith kar taraweeh padhna Makrooh hai balki ba'az fukhaye kiraam ke nazdeek to
               namaz hogi hi nahi.
              </p>
            
              <h3 className="contentSection_subtitle"> Masail-E-Roza :</h3>

              <p className="contentSection_title--content">
              Sawal 1) Baghair Sehri Ke Roza Rakhna Kaisa hai?
              </p>
            
              <p className="contentSection_title--content">
              Jawab 1) Baghair Sehri Ke Roza Rakhna Jaaiz Hai.
              </p>
              <span className='referenceTag'>
                [ Fatawa AalamGiri ]
              </span>
              <p className="contentSection_title--content">
              Magar Mustahab Ye Hai Ke Sehri Kha Kar Roza Rahe Ke Hadees Shareef Main Iski Bahot Fazilate'n 
              Aayi Hain Tibraani Ausat Main Aur Ibne Habbaan Saheeh Me'n Hazrat Ibne Umar RadiyAllahu Ta'Aala 
              Anhuma Se Riwayat Karte Hain ke RasoolAllah ﷺ Ne Farmaya Ke Allah Aur Uske Farishte Sehri Khaane 
              Walo'n Par Durood Bhejte Hain.
              </p>
            
              <p className="contentSection_title--content">
              Aur Imam Ahmed Hazrat Abu Sa'eed Khudri RadiyAllahu Ta'Aala Anhu Se Riwayat Karte Hain Ke Sarkar 
              Aqdas ﷺ Ne Farmaya Sehri Kul Ki Kul Barkat Hai Ise Na Cchodna Agarche Ek Ghoont Paani Hi PeeLe
               Isliye Ke Sehri Khaane Walo'n Par Allah Aur Uske Farishte Durood Bhejte Hain.
              </p>
              
              <p className="contentSection_title--content">
              Sawal 2 ) Kya Sehri Khana Bhi Niyyat Hai?
              </p>
            
              <p className="contentSection_title--content">
              Jawab 2) Jee Haan, Sehri Khana Bhi Niyyat Hai Khwa Ramadan Ke Roze Ke Liye Ho Ya Kisi Aur Roza Ke
               Liye, Magar Jab Sehri Khate Waqt Ye Irada Hai Ke Subah Ko Roza Na Hoga To Ye Sehri Khana Niyyat
                Nahi.
              </p>
              <span className='referenceTag'>
              [ Jawahira, Rudul Muhtaar, Bahare Shari'at] [ Muslim Khatoon May2017, S:21 ]
              </span>

              <p className="contentSection_title--content">
              Sawal 3) Aehtalaam Hojane Ya Jima Karne Ke Ba'd Ghusl Na Kiya Pura Din Isi Haalat Main Guzara , 
              To Is Haalat Main Roza Ada Hojayega Ya Nahi?
              </p>
              
              <p className="contentSection_title--content">
              Jawab 3) Aehtalaam Hojane Ya HamBistari Karne Ke Ba'd Ghusl Na Kiya Aur Isi HaaLat Main Pura Din
               Guzaar Diya To Wo Namazo'n Ke Cchod Dene Ke Sabab Sakht Gunehgaar Hoga. Magar Roza Ada Hojayega.
              </p>
              <span className='referenceTag'>
              [ Behrul Raayiq, J:2 , S:273 ] [ Anwarul Hadees , S:278 ]
              </span>

              <p className="contentSection_title--content">
              Sawal 4) Dhoodh Pilane Wali Aur Haamila Aurat Roza Rakhe Ya Na Nahi?
              </p>
            
              <p className="contentSection_title--content">
              Jawab 4) Dhood Pilaane Wali Aur Haamila Aurat Ko Roza Na Rakhne Ko Rukhsat Sirf Is Surath 
              Main Hai Ke Bacche Ko Ya Khud Usko Roza Se Nuqsaan Pohnche. (Warna Rukhsat Nahi Hai.)
              </p>
              <span className='referenceTag'>
              [ Ash'atul LamAat , J:2 , S 94 ] [ Anwarul Hadees , S:277 ]
              </span>
              
              <p className="contentSection_title--content">
              Sawal 5) Kya Napaaki Ki Haalat Main Roza Ki Niyyat Kar Sakte Hain?
              </p>
            
              <p className="contentSection_title--content">
              Jawab 5) Haalate Janabat Main Roza Ki Niyyat Kar Sakte Hain. Lekin Agar Aurat Haalate 
              Haiz-o-Nifaas Main Hon To Roza Ki Niyyat Nahi Kar Sakti , Is Liye Ke Aisi Aurato'n Ko Roza 
              Rakhna Haraam Hai.
              </p>
            
              <p className="contentSection_title--content">
              (Bahare Shari'at , H:5, S:119) Main Hai Ke : Janabat Ki Haalat Main Subah Balke 
              Agarche Saara Din Junub Raha , Roza Naa Gaya Magar Itni Der Tak Qasdan Ghusl Na Karna Ke
               Namaaz Qaza Hojaye Gunah-o- Haraam Hai.
              </p>
             
              <p className="contentSection_title--content">
              Sawal 6 ) Injection Lagwane Se Roza Totega Ya Nahi?
              </p>
              <p className="contentSection_title--content">
              Jawab 6) Injection Lagwane Se Roza Nahi Totega Chahe Gosht Main Lagwaye Ya Rag Main Kyun Ke 
              Is Silsile Main Hukm Shar'ee Ye Hai Ke Qasdan Khaane Peene Aur Jima Ke Aelawa Wo Aisi Dawa Ya 
              Ghiza Se Roza Totega Jo Pet Ya Dimaagh Main Daakhil Ho. Dawa Tar Ho Ya Khusk Jaisa Ke Fatawa
               AalamGiri , J:1 Matbu'aa Raheemiya S: 104 Main Hai.
              </p>
              <p className="contentSection_title--content">
              Tarjuma: Dimaagh Main Daakhil Hone Se Isliye Roza Totega Ke Dimaagh Se Pet Tak Ek Manfaz Hai 
              Jiske Zari'ah Dawa Waghera Pet Main Pohanch Jati Hai Warna Dar_Haqeeqat Pet Main Kisi Cheez Ka
               Daakhil Hokar Ruk Jana Hi Fasaade Swam Ka Sabab Hai. Jaisa Ke Behrul Raayiq , J:2 , S:300 Main Hai.
              </p>
              <p className="contentSection_title--content">
              Tarjuma: Gosht Main Injection Lagne Se Dawa Pet Ya Dimaagh Main Kisi Manfaz Ke Zari'ah Daakhil Nahi 
              Hoti Balke MasaaMaat Ke Zari'ah Pure Badan Main Phail Jati Hai Aur MasaaMaat Ke Zari'ah Kisi
               Cheez Ke Daakhil Hone Se Roza Nahi Totta. Jaisa Ke Fatawa AalamGiri , J:1 , S:104 me Hai.
              </p>
              <p className="contentSection_title--content">
              Tarjuma: Isi Tarah Rag Main Injection Lagne Se Bhi Dawa Pet Ya Dimaagh Main Manfaz Se Daakhil 
              Nahi Hoti Balke Rago'n Se Dil Ya Jigar Main Pohanchti Hai Aur Phir Waha Se Rago'n Ke Zari'ah 
              Pure Badan Main Phailti Hai In Rago'n Ko Sharaa'een Ya Aawarda Kehte Hai. Jo Bil_Tarteeb Dil 
              Ya Jigar Se Nikli Huwi Hai. (Ref:Fatawa Faqhee-E- Millat , S:345)
              </p>
                        
              <p className="contentSection_title--content">
              Sawal 7) Haalate Roza Main Glucoes Lagwana Kaisa Hai?
              </p>
              <p className="contentSection_title--content">
              Jawab 7 ) Jaaiz Hai, Agarche Isse Bhook Bhi Khatam Hojaye Kyun Ke Asl Qaa'ida Ye Hai Ke 
              Manfaz Ke Zariya Kisi Dawa Ya Ghiza Ka Maada Ya Damaagh Main Daakhil Hona Roze Ko Faasid Karta
               Hai. Masaam Ya Rag Ke Zariya Koyi Cheez Daakhile Badan Hoto Isse Roza Na Jayega, Glucoes Ki 
               Drop Lagwane Se Manfaz Ke Zariye Koyi Cheez Andar Nahi Jaati. Glucoes Lagana Haalate Izteraab 
               Main Ho Warna Makruh Hai.
              </p>
              <p className="contentSection_title--content">
              Sawal 8) Kya Cigarette (Smoking) Se Roza Toot Jata Hai?
              </p>
              <p className="contentSection_title--content">
              Jawab 8)  Huqqa , Sigaar , sigarette , Chart Waghera Peene Se Roza Roza Jata Rehta Hai. Agarche
               Apne Khayaal Main Halaq Tak Dhuwa'n Pohanchta Ho , Balke Paan Ya Sirf Tambaco Khane Se Bhi Roza 
               Jata Rahega Agarche Pek Thook Di Ho Ke Uske Bareek Ajza Zaroor Halaq Main Pohanchte Hain. 
              </p>
              <span className='referenceTag'>
              Bahare Shari'at , Hissa:5 , Safa: 58&59
              </span>
              <p className="contentSection_title--content"></p>
              Sawal 9) Naak Main Spray Karne Se Roza Totega Ya Nahi?         
              <p className="contentSection_title--content">
              Jawab 9)  Roza Toot Jayega. Is Roza Ke Badle Main Ek Roza Rakhna Laazim Hoga. 
              </p>
              <span className='referenceTag'>
              [ Fatawa AhleSnnat ] 
              [ Muslim Khatoon , May2017 ]
              </span>
              <h3 className="contentSection_subtitle">   #Masla #of #Zakaat :</h3>
              <h4 className="contentSection_subheading">#Sahib-e-Nisab kon kon hain</h4>
              <p className="contentSection_title--content">
              Wo jis k pas 52 1/2 tola chandi ho ya 7 1/2 tola sona ho ya 52 1/2 tola chandi jitni raqam ho ya phr
               Js k pas kuch sona ho kuch chandi ho or kuch rupya ho or 3no mila kar nisab ki raqam ko pohonchy wo
                sahib-e- nisab kehlaty hain jin par zakaat farz hai Is sal ki jo nisab ki raqam bnti hai wo taqrebn 
                36,000 sy 38,000 kay darmiyan bnti hai yani taqrebn 52 1/2 tola chandi jitni raqam
              </p>
              <h4 className="contentSection_subheading">#Zakaat kesy nikali jaye</h4>
            
              <p className="contentSection_title--content">
              Apny maal ki 2.5(dhai) feesad zakaat hoti hai Maslan 100 rupay par 2.5 rupay isi tarha 100000 par
               2500 rupay Apny mal ki zakat ks tarha nikalen Agr ap k pas raqam nisab ko pohonchy ya is sy ziada 
               ho to usay taqseem(divide) kar den apny rupay se.
              </p>
              <h3 className="contentSection_subtitle"> Galatfahmiya'n aur unki islaah</h3>
             
              <p className="contentSection_title--content">
              Q. kuch log samjhte hain ki muh me maujood thook ya balgam nigal jane se roza toot jata hai ya
               makrooh ho jata hai isliye wo baar baar thookte rahte hain...?
              </p>
              <p className="contentSection_title--content">
              Ans.sahi masla ye hai ki muh me maujood thook ya balgam nigalne se roza bilkul nahi tootega. ha agar koi
               muh se bahar maslan hatheli par thook kar apna thook ya balgam dubara daal kar nigal jaye to fir 
               toot jayega, lekin aisa aam taur par koi nahi krta.
              </p>
              <p className="contentSection_title--content">
              Q. kuch log samjhte hain ki sehri me aankh na khule aur sehri khana chhoot jaye to roza nahi hota...?
              </p>
              <p className="contentSection_title--content">
              sahi masla ye hai ki sehri roza ke liye shart nahi yani zaroori nahi apne raat me roze ki niyat kar 
              li thi yaani dil me roza rakhne ka iraada tha fir sehri me aankh na bhi khuli tab bhi roza ho jayega
               haa jaanboojh kar sehri na karna apne aapko azeem sunnat se mehrrom karna hai.
              </p>
              <p className="contentSection_title--content">
              Q. kuch log samjhte hain ki jab tak azaan hoti rahe sehri me khana-peena jaari rakha ja sakta hai 
              isliye wo azaan hoti rahti hai aur wo khate-peete rahte hain?
              </p>
              <p className="contentSection_title--content">
              sahi mas'ala ye hai ki Namaz-E-Fajr ka waqt tab shuru hota hai jab sehri ka waqt khatm ho jata hai, 
              jo sehri ka waqt khatm ho jane ke baad bhi khata-peeta rahta hai usne apna Roza barbad kiya.
              </p>
              <p className="contentSection_title--content">
              Aur Mazeed Farmate Hain Is (Haiz-o-Nifaas) Haalat Main Roza Rakhna Aur Namaaz Padhna Haraam Hai. 
              </p>
              <span className='referenceTag'>[Bahare Shari'at , H:2 , S:102]</span>
              <h3 className="contentSection_subtitle">Mahe Ramzan ki Fazilat</h3>
              <p className="contentSection_title--content">
              Mahe Ramzan ki Aamad par ek martaba Huzur Nabi-E-Kareem صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne irshad farmaya ki :
              </p>
              <p className="contentSection_title--content">
              Tum par ek aisa ba-barkat maheena aane wala hai jiske roze Allah Paak ne tum par Farz kiye hain. 
              isme Jannat ke darwaze khol diye jate hain aur Jahannam ke darwaze band kar diye jate hain aur 
              shayateen qaid kar diye jate hain. jisne is maheene me (ek ghoont pani ya ek khajoor hi se) kisi
               rozedar ko (Raza-E-ilahi aur husool-E-sawab ke liye) iftaar karaya to uske liye gunaaho ki maghfirat
                aur jahannam ki aag se aazadi ka zariya hoga aur usko rozadar ke barabar sawab diya jayega bagair
                 uske ki rozadar ke sawab me koi kami ki jaye aur jo shakhs kisi rozadar ko pet bhar khana khila 
                 de to usko Allah Paak meri Hauze Kausar se aisa sairab karega jisko peene ke baad usko jannat me
                  dakhil hone tak kabhi piyas hi nahi lagegi.
              </p>
              <p className="contentSection_title--content">
              is Maah ka ibtidayi Ashra'h Rahmat ka hai, Darmiyani Ashra'h Maghfirat ka aur Aakhiri Ashra'h 
              Jahannam ki Aag se Aazadi ka hai.
              </p>
              <h3 className="contentSection_subtitle">Roza</h3>
              <h4 className="contentSection_subheading">Roza ki Farziyat</h4>
              <p className="contentSection_title--content">
              Roza bhi misl namaz ke Farz-E-Ain hai, iski farziyat ka munkir Kafir aur bila uzr chhorne wala sakht 
              gunahgar hai aur jo bacche roza rakh sakte ho unko rakhaya jaye aur qavi mazboot ladke-ladkiyo ko mar
               kar rakhaya jaye.
              </p>
              <span className='referenceTag'>Durr-e-Mukhtar </span>
              <h3 className="contentSection_subtitle">Roza ki Tareef</h3>

              <p className="contentSection_title--content">
              Shariyat me roza ke ma'na hain , Allah ki ibadat ki niyat se subah sadiq se lekar suraj doobne
               tak khane, peene aur jima se apne ko roke rakhna.
              </p>
              <h3 className="contentSection_subtitle">Roza todne wali cheezo ka bayan</h3>
        
              <p className="contentSection_title--content">
              * Khane, peene ya Jima karne se roza toot jata hai jabki rozadar hona yaad ho aur agar rozadar hona
               yaad na raha aur bhool kar kha liya , pee liya ya jima kar liya to roza na gaya.
              </p>
              <p className="contentSection_title--content">
              * Huqqa, Cigarette, Beedi ya Cigar peene se roza toot jata hai.
              </p>
              <p className="contentSection_title--content">
              * Pan ya tambaku khane se bhi roza toot jata hai agarche peek thook diya ho.
              </p>
              <p className="contentSection_title--content">
              * Shakkar Cheeni Gudh wagairah aisi cheeze jo muh me rakhne se ghul jati hain, muh me rakhi aur
               thook nigal gaya to roza toot gaya.
              </p>
         </div>
    </div>
  )
}

export default Ramzan